var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileFriend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.2396C0 11.1863 2.88 10.669 6.26087 10.669C9.64174 10.669 12.5217 11.2022 12.5217 13.2555C12.5217 15.3088 9.64174 15.8261 6.26087 15.8261C2.88 15.8261 0 15.2929 0 13.2396ZM2.12033 4.70805C2.03773 4.14885 2.08093 3.5793 2.24704 3.03724C2.41316 2.49519 2.69838 1.99306 3.08376 1.56421C3.46915 1.13536 3.94586 0.789608 4.48222 0.549964C5.01858 0.31032 5.6023 0.182279 6.19458 0.17431C6.78686 0.166341 7.37415 0.278627 7.91739 0.503745C8.46063 0.728864 8.94737 1.06164 9.34529 1.47995C9.74322 1.89827 10.0432 2.39255 10.2253 2.92992C10.4074 3.46728 10.4674 4.03544 10.4014 4.59664V4.70805C10.2881 5.67091 9.81029 6.56131 9.05747 7.2122C8.30465 7.8631 7.32858 8.22978 6.31238 8.24345C5.29618 8.25712 4.30968 7.91686 3.53789 7.28648C2.7661 6.6561 2.26205 5.77891 2.12033 4.81948V4.70805Z",
    fill: "#778797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFriend);
export default __webpack_public_path__ + "static/media/profile_friend.545cbbe67cdaea95ae3724077fc298ce.svg";
export { ForwardRef as ReactComponent };